<template>
  <div>
    <div class="flex flex-wrap -mx-2">

      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-select
          label="Nivel educativo"
          v-model="form.educationLevel"
          :items="educationLevelList"
          defaultOption="Elegir nivel"
        />
      </div>

      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-input
          label="Profesión"
          v-model="form.profession"
          placeholder="Ingresar profesión"
        />
      </div>

    </div>
  </div>
</template>

<script>
import { Constants } from '@/core/utils'

export default {
  props: {
    form: { type: Object, required: true },
    v:    { type: Object, required: true },
  },
  data() {
    return {
      educationLevelList: Object.values(Constants.EducationLevel),
    }
  },
}
</script>

<style lang="stylus" scoped></style>
